import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {BillingService} from '../../service/billing/billingService.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {ExportUtil} from '../../utils/exportUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {StringUtil} from '../../utils/stringUtil.js';
import {BaseComponent} from '../basecomponent.js';


/* global customElements */
class PromotionGrid extends BaseComponent {
	
	static get properties() {
		return {			
		};
	}
	
	constructor() {
		super();
		
		this.local = false;
		
		var promotionGrid = this;
		setTimeout(function(){
			promotionGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var promotionGrid = this;
		
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'vaadin-button',
					itemid: 'refresh',
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:refresh', ' Refresh')
					], 
					listeners: {
						click: function() {
							actionRefresh();
						}
					}
				},
				{	
					tag: 'vaadin-combo-box',
					itemid: 'status',						
					'class': 'spacer-toolbar-item',
					'item-value-path': 'code',
					'item-label-path': 'desc',
					'prevent-invalid-input': true,
					postinit: function(combo) {							
						combo.items = [
							{
								code: 'A',
								desc: 'Active'
							}, {
								code: 'I',
								desc: 'Inactive'
							}
						];
						combo.value = 'A';
					},
					listeners: {
						'selected-item-changed': function(event) {
							if (actionRefresh){
								actionRefresh();
							}
						}
					}
										
				},				
				{
					tag: 'dl-action-button',
					itemid: 'add',
					theme: 'primary',
					'class': 'spacer-toolbar-item',
					permissions: ['ADMIN_BILLING_PROMOTIONS:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:plus', ' Add')
					],
					listeners: {
						click: function() {							
							actionAddEdit();
						}
					}					
				},
				{
					tag: 'dl-action-button',
					itemid: 'edit',
					'class': 'spacer-toolbar-item',
					permissions: ['ADMIN_BILLING_PROMOTIONS:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:edit', ' Edit')
					],
					listeners: {
						click: function() {							
							actionAddEdit(grid.selectedItems[0]);
						}
					}
				},							
				{
					tag: 'dl-action-button',
					itemid: 'delete',
					theme: 'error primary',					
					permissions: ['ADMIN_BILLING_PROMOTIONS:DELETE'],
					'class': 'spacer-toolbar-item',
					style: 'float: right;',					
					children:[
						ElementUtil.makeIcon('vaadin:close', ' Cancel Now')
					],
					listeners: {
						click: function() {
							actionCancel(grid.selectedItems[0]);
						}
					}
				}			
			]
		});	
		
		
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true,
				listeners: {
					'direction-changed' : function(event) {
						if (event.detail && event.detail.value) {
							grid.currentSortField = event.target.path;
							grid.currentSortDirection = event.detail.value.toUpperCase();
							pagingToolbar.loadCurrentPage();
						}
					}
				}				
			},			
			children: [	
				{						
					path: 'promotionCode',
					header: 'Code',					
					width: '7em'
				},
				{						
					path: 'promotionDesc',
					header: 'Description',					
					'flex-grow': '1'
				},				
				{						
					path: 'promoEffDate',
					header: 'Effective Date',
					width: '9em',
					renderer: function(root, column, rowData) {									
						root.innerHTML = TimeUtil.formatDateOnlyStandard(rowData.item.promoEffDate);						
					}	
				},
				{						
					path: 'promoCancelDate',
					header: 'Cancel Date',						
					width: '9em',
					renderer: function(root, column, rowData) {
						if (rowData.item.promoCancelDate) {												
							root.innerHTML = TimeUtil.formatDateStandard(rowData.item.promoCancelDate);						
						}
					}
				},
				{						
					path: 'promotionDuration',
					header: 'Duration',					
					width: '7em'
				},
				{						
					path: 'durationUom',
					header: 'Duration UOM',					
					width: '7em'
				},
				{						
					path: 'promotionUseCount',
					header: 'Use Count',					
					'text-align': 'center',
					width: '7em'
				},
				{						
					path: 'maxPromoCount',
					header: 'Max Count',					
					'text-align': 'center',
					width: '7em'
				},
				{						
					path: 'mustSelectAllFlag',
					header: 'Select All',					
					'text-align': 'center',
					width: '7em'
				},
				{						
					path: 'approvedBy',
					header: 'Approved By',					
					'text-align': 'center',
					width: '7em'
				}				
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;
					grid.selectedItems = item ? [item] : [];
					if (grid.selectedItems.length > 0) {						
						ElementUtil.query(toolbar, 'edit').disabled = false; 
						if (grid.selectedItems[0].activeStatus === 'A') {
							ElementUtil.query(toolbar, 'delete').disabled = false;
						} else {
							ElementUtil.query(toolbar, 'delete').disabled = true;
						}
					} else {						
						ElementUtil.query(toolbar, 'edit').disabled = true;
						ElementUtil.query(toolbar, 'delete').disabled = true;
					}	
				}
			}
		});		
		
		var pagingToolbar = ElementUtil.create({
			tag: 'dl-paging-toolbar',
			slot: 'footer',
			pageSize: 200,
			postinit: function(element) {
				element.grid = grid;
				element.loader = function(backingGrid, pageNumber, pagingToolbar) {
					var pageRange = pagingToolbar.pullRange();
					var loadMask = grid.showLoading();
					
					promotionGrid.currentFilter = {
						offset: pageRange.offset,
						max: pageRange.max,
						sortField: backingGrid.currentSortField,
						sortOrder: backingGrid.currentSortDirection,
						status: ElementUtil.query(toolbar, 'status').value	
					};
					
					var successHandler = function(records) {
						loadMask.remove();
						grid.activeItem = null;						
						grid.items = records.data;
						
						promotionGrid.fullDataSet = records.data;						
						pagingToolbar.totalRecords = records.totalNumber;
						pagingToolbar.updatePager();						
					};
					
					BillingService.getBundlePromotionService().getPromotions(promotionGrid.currentFilter)
					.then(function(records){							
						successHandler(records);
					});
										
				};
			},
			listeners: {
				ready: function() {					
					pagingToolbar.loadCurrentPage();
				}
			}
			
		});		
		
		var footer = ExportUtil.createExportFooter({
			pagingToolbar: pagingToolbar,
			grid: grid,
			itemid: 'promotions',
			onDetail: function() {
				ExportUtil.exportGridItemsAsCsv(grid.items, 'promotions.csv');
			}
		});

		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbar,
				grid,
				footer.footerContainer
			]
		});		
		promotionGrid.append(flexLayout);		
		
		
		var actionRefresh = function() {
			pagingToolbar.loadPage(1);			
		};
		
		var actionAddEdit = function(record) {
			
			var addEditWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Add/Edit Promotion Code',
				icon: 'lumo:edit',
				listeners: {
					ready: function() {						
						addEditWin.show();
								
						var productItems = [];
						var productItemGrid = ElementUtil.create({
							tag: 'vaadin-grid',
							theme: 'row-stripes column-borders',
							'column-reordering-allowed': '',
							style: 'height: 100%;',
							slot: 'primary',
							defaults: {
								tag: 'vaadin-grid-sort-column',
								resizable: true				
							},			
							children: [	
								{						
									path: 'promotionProductItemPK',
									header: 'Product Item',					
									width: '9em',
									renderer: function(root, column, rowData) {
										root.innerHTML = rowData.item.promotionProductItemPK.productCode + '-' + rowData.item.promotionProductItemPK.featureProductCode;
									}
								},	
								{						
									path: 'description',
									header: 'Description',					
									'flex-grow': '1'
								},	
								{						
									path: 'promoDiscountAmt',
									header: 'Discount Amount',					
									width: '7em',
									renderer: function(root, column, rowData) {										
										var actionType = ElementUtil.query(formPanel, 'promotionAction').value;
										if (actionType !== 'FLAT') {
											root.innerHTML = rowData.item.promoDiscountAmt + '%';
										} else {										
											root.innerHTML = StringUtil.currencyFormat(rowData.item.promoDiscountAmt);
										}
									}
									
								}
							],
							listeners: {
								'active-item-changed': function(event) {
									const item = event.detail.value;
									productItemGrid.selectedItems = item ? [item] : [];
									if (productItemGrid.selectedItems.length > 0) {																
										ElementUtil.query(formPanel, 'remove').disabled = false;
									} else {																
										ElementUtil.query(formPanel, 'remove').disabled = true;
									}	
								}
							}
						});			
								
						var formPanel = ElementUtil.create({
							tag: 'dl-form-panel',
							itemid: 'form',
							children: [
								{
									tag: 'vaadin-form-layout',										
									children: [										
										{
											tag: 'vaadin-text-field',
											label: 'Promotion Code',
											name: 'promotionCode',
											required: true,
											maxlength: 20
										},	
										{
											tag: 'vaadin-text-field',
											label: 'Short Description',
											name: 'promotionDesc',											
											required: true,
											maxlength: 255
										},
										{
											tag: 'vaadin-text-field',
											label: 'Detail Description',
											name: 'promotionDetailDesc',											
											maxlength: 2048
										},
										{
											tag: 'vaadin-text-field',
											label: 'Approved By',
											required: true,
											name: 'approvedBy',											
											maxlength: 80
										},										
										{
											tag: 'vaadin-date-picker',
											label: 'Effective Date',
											required: true,
											name: 'promoEffDate',
											value: TimeUtil.formatDateForTimeField(new Date()),
											maxlength: 16
										},										
										{
											tag: 'vaadin-date-picker',
											label: 'Cancel Date',
											name: 'promoCancelDate',											
											maxlength: 255
										},
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'vaadin-number-field',
											label: 'Duration',
											required: true,
											name: 'promotionDuration',											
											min: 0,
											max: 999
										},
										{
											tag: 'vaadin-combo-box',											
											label: 'Duration UOM', 
											name: 'durationUom',											
											value: 'M',
											'item-value-path': 'code',
											'item-label-path': 'description',
											postinit: function(combo) {
												Service.getLookupService().getLookupValues('PromotionDurationUOM').then(function(data){
													combo.items = data;
													combo.required = true;
												});
											}
										},										
										{
											tag: 'vaadin-number-field',
											label: 'Use Count',
											name: 'promotionUseCount',
											'helper-text': 'How many times it has been used',
											value: 0,
											min: 0,
											max: 9999
										},
										{
											tag: 'vaadin-text-field',
											label: 'Max Promo Count',
											'helper-text': 'Max times the code can be used',
											name: 'maxPromoCount',											
											maxlength: 80
										},										
										{
											tag: 'vaadin-combo-box',
											itemId: 'promotionAction',
											label: 'Action', 
											name: 'promotionAction',											
											value: 'FLAT',
											'item-value-path': 'code',
											'item-label-path': 'description',
											postinit: function(combo) {
												Service.getLookupService().getLookupValues('PromotionAction').then(function(data){
													combo.items = data;
													combo.required = true;
												});
											},
											listeners: {
												change: function() {
													actionRefreshItems();
												}
											}
										},
										{
											tag: 'vaadin-checkbox',									
											name: 'mustSelectAllFlag',
											label: 'Must Select All Products'	
										},
										{
											tag: 'dl-section-title',
											title: 'Product Items',
											colspan: 2
										},							
										{
											tag: 'div',
											style: 'height: 200px',
											colspan: 2,
											children: [
												{
													tag: 'dl-flex-layout',
													children: [
														{
															tag: 'dl-toolbar',
															slot: 'toolbar',
															theme: 'spacing',
															children: [																				
																{
																	tag: 'vaadin-button',
																	itemid: 'add',
																	theme: 'primary',
																	'class': 'spacer-toolbar-item',
																	children:[
																		ElementUtil.makeIcon('vaadin:plus', ' Add')
																	],
																	listeners: {
																		click: function() {							
																			actionAddProduct();
																		}
																	}					
																},																						
																{
																	tag: 'vaadin-button',
																	itemid: 'remove',
																	theme: 'error primary',																						
																	'class': 'spacer-toolbar-item',
																	style: 'float: right;',					
																	children:[
																		ElementUtil.makeIcon('vaadin:close', ' Remove')
																	],
																	listeners: {
																		click: function() {
																			actionRemoveProduct(productItemGrid.selectedItems[0]);
																		}
																	}
																}			
															]
														},
														productItemGrid													
													]
												}
											]										
										},										
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'div',
											style: 'text-align: center;',
											colspan: 2,
											defaults: {
												tag: 'vaadin-button'
											},
											children: [
												{
													theme: 'primary',
													children: [
														ElementUtil.makeIcon('vaadin:database', ' Save')
													],
													listeners: {
														click: function() {															
																
															formPanel.submitForm({
																preSubmit: function(data) {
																
																	var promotionModel = {
																		promotionCode: data,
																		productItems: []
																	};
																	
																	if (!promotionModel.promotionCode.mustSelectAllFlag) {
																		promotionModel.promotionCode.mustSelectAllFlag = false;
																	}
																	
																	//construct product items
																	productItems.forEach(function(item){																		
																		promotionModel.productItems.push({
																			currencyCode: 'USD',
																			promoDiscountAmt: item.promoDiscountAmt,
																			promotionProductItemPK: {
																				promotionCode: data.promotionCode,
																				productCode: item.promotionProductItemPK.productCode,
																				featureProductCode: item.promotionProductItemPK.featureProductCode
																			}
																		});
																	});
																
																	return promotionModel;
																},
																actualCall: function(data) {
																	return BillingService.getBundlePromotionService().savePromotion(data, record ? true : false);
																},
																success: function(data, responseData) {
																	window.DL.MessageUtil.showToast('Success', 'Saved Promotion Code', {
																		theme: 'success',
																		position: 'top-stretch'
																	});
																	if (formPanel.successCallback) {
																		formPanel.successCallback();
																	}
																	actionRefresh();
																	addEditWin.close();
																}
															});
															
														}
													}
												},
												{
													theme: 'tertiary',
													innerHTML: 'Cancel',
													style: 'margin-left: 10px;',
													listeners: {
														click: function() {
															//cancel
															addEditWin.close();
														}
													}
												}
											]
										}
									]
								}
							]

						});
						addEditWin.addToContentElement(formPanel);	
						
						if (record) {
							
							//load detailed record
							var loadMask = formPanel.showLoading();
							BillingService.getBundlePromotionService().getPromotionDetail(record.promotionCode).then(function(detail){
								loadMask.remove();
								
								
								
								
								formPanel.load(record);
								
								productItems = detail.productItems;								
								actionRefreshItems();								
															
							});
						}
						
						var actionRefreshItems = function() {
							productItemGrid.activeItem = null;
							productItemGrid.items = productItems.slice(0);				
						};
						
						var actionAddProduct = function() {
						
							var addItemWin = ElementUtil.create({
								tag: 'dl-dialog',
								title: 'Add Product Item',
								icon: 'lumo:edit',
								width: '75%',
								height: 250,
								listeners: {
									ready: function() {						
										addItemWin.show();
																				
										var itemFormPanel = ElementUtil.create({
											tag: 'dl-form-panel',
											itemid: 'form',
											children: [
												{
													tag: 'vaadin-form-layout',										
													children: [																								
														{
															tag: 'vaadin-combo-box',											
															itemid: 'productItem',
															label: 'Product Item', 
															name: 'productItem',																													
															'item-value-path': 'code',
															'item-label-path': 'itemDesc',
															postinit: function(combo) {
																
																BillingService.getProductService().getEffectiveProductItems().then(function(data){
																	//format the code
																	var productItems = [];
																	data.forEach(function(item){																		
																		var productItem = item.productItem;
																		productItem.code = productItem.productItemPK.productCode + "-" + productItem.productItemPK.featureProductCode;
																		productItems.push(productItem);
																	});
																	productItems.sort(function(a, b){
																		return a.itemDesc.localeCompare(b.itemDesc);
																	});
																	
																	combo.items = productItems;
																	combo.required = true;
																});
															}
														},										
														{
															tag: 'vaadin-number-field',
															label: 'Discount Amount',
															name: 'promoDiscountAmt',
															required: true,															
															min: 0,
															max: 999999
														},							
														{
															tag: 'hr',
															colspan: 2
														},
														{
															tag: 'div',
															style: 'text-align: center;',
															colspan: 2,
															defaults: {
																tag: 'vaadin-button'
															},
															children: [
																{
																	theme: 'primary',
																	children: [
																		ElementUtil.makeIcon('vaadin:database', ' Save')
																	],
																	listeners: {
																		click: function() {		
																			var data = itemFormPanel.getData();
																			var productItemCB = ElementUtil.query(itemFormPanel, 'productItem');
																			var productItemValue = productItemCB.selectedItem;
																			data.description = productItemValue.itemDesc;
																			data.promotionProductItemPK = {
																				productCode: productItemValue.productItemPK.productCode,
																				featureProductCode: productItemValue.productItemPK.featureProductCode
																			};																			
																			
																			productItems.push(data);
																			actionRefreshItems();
																			addItemWin.close();
																		}
																	}
																},
																{
																	theme: 'tertiary',
																	innerHTML: 'Cancel',
																	style: 'margin-left: 10px;',
																	listeners: {
																		click: function() {
																			//cancel
																			addItemWin.close();
																		}
																	}
																}
															]
														}
													]
												}
											]

										});
										addItemWin.addToContentElement(itemFormPanel);	
										
									}
								}
							});
							
						};
						
						var actionRemoveProduct = function(productItem) {
							var newItems = [];
							productItems.forEach(function(item){
								if (!(item.promotionProductItemPK.productCode === productItem.promotionProductItemPK.productCode  
									&& item.promotionProductItemPK.featureProductCode === productItem.promotionProductItemPK.featureProductCode)) {
									newItems.push(item);
								}
							});	
							productItems = newItems;
							actionRefreshItems();
						};
					}
				}
			});
		
						
		};
		
		var actionCancel = function(record) {
			var summary = window.DL.MessageUtil.ellipseText(record.promotionCode, 20);
			window.DL.MessageUtil.showConfirm({
				title: 'Confirm Cancel',
				message: 'Are you sure you want to cancel ' + summary + ' promotion code?',
				buttons: [
					{
						text: 'Yes',
						handler: function() {
							var loadMask = grid.showLoading('Canceling...');													
							
							BillingService.getBundlePromotionService().deletePromotion(record.promotionCode).then(function(){
								loadMask.remove();
								window.DL.MessageUtil.showToast('Success', 'Canceled: ' + summary, {									
									theme: 'success'
								});
								actionRefresh();
							});															
							
						}	
					},
					{
						text: 'No'
					}
				]
			});				
		};		

	}
	
};
customElements.define('dl-promotions-grid', PromotionGrid);
